import { DEFAULT_STATE } from '@/constants'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
    listCampaign: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listAdGroupSpp: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listAd: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    campaignDetail: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listAdGroupCampaign: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listAdCampaignSpp: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listAdCampaignSp: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listAdCampaignManual: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listIdentity: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listVideoTikTok: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listVideoCreative: {
      content: [],
      paging: {
        total: 0,
        page: 1,
        totalPage: 1,
      },
    },

    listVideoLibrary: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listThumbnailVideoCreative: {
      content: [],
      paging: {
        total: 0,
        page: 1,
      },
    },

    listLocation: [],

    videoSyncInfo: {},
  },
  getters,
  mutations,
  actions,
}
